import api from 'Application/api/api';

const respondForExistingProject = (signal, values) =>
	api.put('/inquiries/respond-existing-project', values, {
		signal,
	});

export default respondForExistingProject;
